import Vue from "vue";
import App from "./App.vue";
import "./plugins/antd/ant-design-vue.js";
import "./plugins/vue-select/vue-select.js";
import "./plugins/copy-clipboard/copy-clipboard.js";
import "./plugins/mis/misUI.js";
import "./plugins/xlsx/xlsx.js";
import "vue-select/dist/vue-select.css";
import router from "./router";
import store from "./state/store";
import message from "@/mixins/HandleMessage";

Vue.config.productionTip = false;
Vue.prototype.$serviceUrl = process.env.VUE_APP_SERVICEURL;
Vue.prototype.$urlPandapaKita = process.env.VUE_APP_PANDAPAKITA;
window.Event = new Vue();
Vue.mixin(message);

const allowCrossDomain = function (req, res, next) {
  res.header("Access-Control-Allow-Origin", "*");
  res.header("Access-Control-Allow-Methods", "*");
  res.header("Access-Control-Allow-Headers", "*");
  next();
};

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some((record) => record.meta.isPublic);
  const isSpecialMenu = to.matched.some((record) => record.meta.isSpecialMenu);
  const typePage = to.matched.some((record) => record.meta.typePage);
  if (isPublic) {
    store.dispatch("SET_PUBLIC", isPublic);
    next();
  } else if (isSpecialMenu) {
    store.dispatch("SET_SPECIALMENU", isSpecialMenu);
    next();
  } else if (typePage) {
    store.dispatch("SET_TYPEPAGE", typePage);
    next();
  } else {
    next();
  }
});

new Vue({
  data: { loading: false },
  router,
  store,
  message,
  allowCrossDomain,
  render: (h) => h(App),
}).$mount("#app");
